import { bool } from "prop-types";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import {
  useEstimateEditorSettings,
  usePresetFieldNames,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  ValueCell,
  HeaderPriceActions,
  VisibilityButton,
} from "@tools";

export const CostCell = observer((cellProps) => {
  const { allowEdition, isProposal, useProfitability } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { hideSummaryCost } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryCost);
  
  return (
    <ValueCell
      colName={ SummaryColumns.COST }
      isHeader
      useDynamicWidth
      className={className}
      textPresetClass="preset-price"
      style={{ cursor: allowEdition && "grab" }}
      {...cellProps}
    >
      <span className="preset-tableSummaryHeader pt-cost">
        { getFieldName(useProfitability ? "pt-revenue" : "pt-cost") }
      </span>
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny"
          inColumn right={8}
          hidden={hideSummaryCost}
          onChange={structure.visibility.setHideSummaryCost}
        />
      }
      {
        allowEdition &&
        <HeaderPriceActions absolute />
      }
    </ValueCell>
  )
})

CostCell.propTypes = {
  extendPadding: bool,
}